<template>
	<div  v-loading="pageLoading" style="width: 210px;display: flex;justify-content: center;margin-top: 10px;">
		<div style="width: 210px;">
			<el-select size="small" v-model="classfiyValue" 
				placeholder="请选择分类数据" @change="changeSelectClassfiy">
				<el-option v-for="classfiyItem in classfiy" :key="classfiyItem.id" :label="classfiyItem.description.name"
					:value="classfiyItem.id">
				</el-option>
			</el-select>
			<el-tabs  :addable="false" :closable="true" style="margin-top: 10px;" @tab-click="clickTab" v-model="editableTabsValue" type="card" @edit="handleTabsEdit">
				<el-tab-pane :key="index" v-for="(item, index) in selectClassfiy" :label="item.description.name"
					:name="item.id + ''">
					<div style="display: flex;flex-direction: column;justify-content: center;">
						<div
							style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 20px;">
							<div
								style="display: flex;align-items: center;background-color: #F6F7F9;height: 32px;width: 210px;justify-content: space-between;font-size: 14px;">
								<div style="font-size: 12px;margin-left: 6px;">
									最多数量: 
								</div>
								<input size="small" v-on:input="valueChange($event,item)" :value="item.selectListIds.length" style="width: 100px;border: 0px;background-color: none;font-size: 14px;margin-right: 6px;"/>
							</div>
						</div>
						<!-- <el-select v-model="goodsValue" filterable remote :remote-method="remoteMethod" reserve-keyword
							placeholder="请输入关键词" @change="changeGoodsName($event,item)" :loading="loading">
							<el-option v-for="goodsItem in goodsList" :key="goodsItem.id" :label="goodsItem.name"
								:value="goodsItem.id">
							</el-option>
						</el-select> -->
					<!-- 	<draggable style="border: solid 1px #8C62FF ;margin-top: 15px;height: 400px;border-radius: 10px;" v-model="item.selectList"
							:group="{name: 'goods',pull:false,put:false,sort:true}" animation="500">
							<transition-group  style="width: 220px;" class="center-group">
								<div style="display: flex;margin: 4px;background-color: #f4f4f4 ;padding: 10px;display: flex;justify-content: space-between;" :key="selectGoodsIndex" v-for="(selectGoodsItem,selectGoodsIndex) in item.selectList">
									<div style="width: 140px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">{{selectGoodsItem.name}}</div>
									<div @click="delSelectGoods(item,selectGoodsIndex)" style="margin-left: 10px;color: #8C62FF ;cursor: pointer;">删除</div>
								</div>
							</transition-group>
						</draggable> -->
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
	import draggable from 'vuedraggable'
	import lodash from 'lodash';
	import {
		getCategories,
		getDesignProducts,
		getAutocomplete
	} from '../../api/all.js'
	export default {
		components:{
			draggable
		},
		props: {
			type: {
				type: String,
				default: "design"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				pageLoading:false,
				classfiyValue:"",
				loading: false,
				goodsValue: "",
				name: '',
				textValue: "zh_cn",
				classfiyTextValue: "zh_cn",
				editableTabsValue: "1",
				classfiy: [],
				goodsList: [],
				selectList:[],
				selectClassfiy:[],
				goodsListObj:{}
			}
		},
		async mounted() {
			let wsid = this.$cookies.get("wsid")
			let data = await getCategories({
				wsid
			})
			this.classfiy = data.data.data
			if (this.classfiy.length > 0) {
				this.editableTabsValue = this.classfiy[0].id + ''
			}
			this.selectClassfiy = this.selectdItem.compontChildren[0].data.classfiy
			console.log('this.selectClassfiy11',this.selectClassfiy)
			if(this.selectClassfiy.length > 0) {
				this.editableTabsValue = this.selectClassfiy[0].id + ''
				// this.remoteMethod('')
			}
			this.pageLoading = true
			this.selectClassfiy.forEach(async selectClassfiyItem=>{
				let wsid = this.$cookies.get("wsid")
				let products = await getDesignProducts({
					wsid,
					id: selectClassfiyItem.id,
					name: selectClassfiyItem.name
				
				})
				this.goodsListObj[selectClassfiyItem.id] = products.data.data
			})
			this.pageLoading = false
		},
		methods: {
			valueChange(e,item) {
				console.log('e',e.target.value)
				if(!e) {
					e.target.value = 1
				}
				if(!isNaN(e.target.value)) {
					if(parseInt(e.target.value) > this.goodsListObj[this.editableTabsValue].length) {
						e.target.value = this.goodsListObj[this.editableTabsValue].length
						this.$message.error("超出当前分类商品数量")
						return
					}
					let selectList = item.selectList
					item.selectList = []
					item.selectListIds = []
					this.goodsListObj[this.editableTabsValue].forEach((itemSelect,indexSelect)=>{
						if(indexSelect < parseInt(e.target.value)) {
							// item.selectList.push(itemSelect)
							item.selectListIds.push(itemSelect.id)
						}
					})
					console.log('123item.selectListIds',item)
				}
				
				
			},
			async changeSelectClassfiy(e) {
				console.log('this.selectClassfiy',e)
				this.classfiy.forEach(async classfiyItem=>{
					if(classfiyItem.id == e){
						let exits = false
						this.selectClassfiy.forEach(selectItem=>{
							if(selectItem.id == classfiyItem.id){
								exits = true
							}
						})
						console.log('exitsexitsexits',exits)
						if(!exits) {
							let wsid = this.$cookies.get("wsid")
							let products = await getDesignProducts({
								wsid,
								id: classfiyItem.id,
								name: classfiyItem.name
							})
							let selectList = []
							let selectListIds = []
							products.data.data.forEach(productsItem=>{
								// selectList.push(productsItem)
								selectListIds.push(productsItem.id)
							})
							
							console.log('products',products)
							this.goodsListObj[classfiyItem.id] = products.data.data
							this.selectClassfiy.push({
								...classfiyItem,
								selectList,
								selectListIds
							})
						}
					}
				})
				console.log('this.selectClassfiy',this.selectClassfiy)
				if(this.selectClassfiy.length == 1) {
					this.editableTabsValue = this.selectClassfiy[0].id + ''
					await this.clickTab({
						index: 0
					})
				}
				this.$nextTick(() => {
					this.classfiyValue = ""
					this.$emit('changeSelectClassfiy')
				})
			},
			delSelectGoods(item,index) {
				item.selectList.splice(index,1)
			},
			async remoteMethod(e) {
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let data = await getAutocomplete({
					wsid,
					name: e,
					id: parseInt(this.editableTabsValue)
				})
				console.log('remoteMethod', data)
				this.goodsList = data.data.data
				this.loading = false
			},
			changeGoodsName(e,item) {
				console.log('changeGoodsName', e)
				if(this.goodsList[e]) {
					item.selectList.push(this.goodsList[e])
					let arr = []
					item.selectList.forEach(selectItem=>{
						arr.push(selectItem.id)
					})
					item.selectListIds = arr
					this.selectdItem.compontChildren[0].data.classfiy = this.selectClassfiy
					console.log('compontChildren', this.selectdItem.compontChildren[0].data)
				}else {
					this.$message.error("添加失败")
				}
				this.$nextTick(() => {
					this.goodsValue = ""
				})
			},
			getLanguage(item) { 
				console.log('item',item)
				let str
				item.descriptions.forEach(item => {
					if (item.locale == this.systemConfig.locale) {
						str = item.name
					}
				})
				return str
			},
			async clickTab(e) {
				try{
					// this.pageLoading = true
					// console.log('e', e)
					// let data = this.selectClassfiy[parseInt(e.index)]
					// console.log('clickTab', data)
					
					// console.log('name', name)
					// let wsid = this.$cookies.get("wsid")
					// let products = await getDesignProducts({
					// 	wsid,
					// 	id: data.id,
					// 	name: this.name
					
					// })
					// this.name = ''
					// this.goodsList = products.data.data
					// this.pageLoading = false
					// console.log('this.goodsList', this.goodsList)
					// this.pageLoading = false
				}catch(e) {
					this.pageLoading = false
				}
			},
			handleTabsEdit(e) {
				console.log('e',e)
				let index = -1
				this.selectClassfiy.forEach((item,key)=>{
					if(item.id == parseInt(e)){
						index = key
					}
				})
				if(index > -1) {
					this.selectClassfiy.splice(index,1)
				}
				if(this.selectClassfiy.length > 0) {
					this.editableTabsValue = this.selectClassfiy[0].id + ''
				}
			}
		}
	}
</script>

<style scoped>
	::v-deep .el-input__inner {
		border: solid 1px #8c62ff;
	}

	::v-deep .el-input__inner:hover {
		border: solid 1px #8c62ff;
	}

	::v-deep .el-input__inner:focus {
		border: solid 1px #8c62ff;
	}
</style>